import type { Item, ArticleVideoType } from '../../types';

export const isArticleVideo = (item: Item): item is ArticleVideoType => {
	return !!(item && item.__typename === 'Article_Video');
};
